{
  "shortcuts": {
    "heading": "Keyboard Shortcuts",
    "file": {
      "heading": "File Operations",
      "save": "Save workout"
    },
    "edit": {
      "heading": "Edit Operations",
      "undo": "Undo",
      "redo": "Redo",
      "copy": "Copy selected steps",
      "cut": "Cut selected steps",
      "paste": "Paste steps",
      "delete": "Delete selected steps"
    },
    "steps": {
      "heading": "Step Management",
      "moveUp": "Move step up",
      "moveDown": "Move step down",
      "createBlock": "Create repetition block",
      "ungroup": "Ungroup block"
    },
    "selection": {
      "heading": "Selection",
      "selectAll": "Select all steps",
      "clear": "Clear selection"
    },
    "help": {
      "heading": "Help",
      "showShortcuts": "Show keyboard shortcuts",
      "showCommandPalette": "Open the command palette"
    }
  }
}
